import { RotateCcw } from 'lucide-react';
import { EntityListView } from '../components/EntityListView';
import { IconButton } from '../components/ui/Button';

const fmtPct = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return '—';
  return `${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
};

const PctCell = ({ v }) => (
  <span className="font-money" style={{
    fontSize: 12, color: v == null || v === '' ? 'var(--muted-2)' : 'var(--ink)',
  }}>{fmtPct(v)}</span>
);

const StatusCell = ({ ativo }) => (
  <span className="chip" style={{
    fontSize: 11, fontWeight: 700,
    background: ativo === false ? 'var(--surface-2)' : 'var(--primary-soft)',
    color:      ativo === false ? 'var(--muted)'     : 'var(--primary)',
    borderColor:ativo === false ? 'var(--border-2)'  : 'var(--primary-line)',
  }}>{ativo === false ? 'Inativo' : 'Ativo'}</span>
);

export function ServicosView({ servicos, loading, onAdd, onEdit, onDelete, onReactivate }) {
  return (
    <EntityListView
      title="Serviços"
      subtitle="Códigos, descrições e alíquotas dos impostos retidos"
      items={servicos}
      loading={loading}
      addLabel="Novo serviço"
      emptyText="Nenhum serviço cadastrado"
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      extraActions={(item) =>
        item.ativo === false ? (
          <IconButton
            icon={RotateCcw}
            title="Reativar serviço"
            onClick={() => onReactivate?.(item)}
          />
        ) : null
      }
      columns={[
        { key: 'codigo', label: 'Código', render: (s) => (
          <span className="font-mono" style={{ fontSize: 12.5, fontWeight: 600,
            padding: '3px 8px', background: 'var(--surface-2)',
            border: '1px solid var(--border)', borderRadius: 6,
            opacity: s.ativo === false ? 0.5 : 1,
          }}>{s.codigo}</span>
        )},
        { key: 'descricao', label: 'Descrição', render: (s) =>
          <span style={{ fontWeight: 500, opacity: s.ativo === false ? 0.5 : 1 }}>
            {s.descricao}
          </span> },
        { key: 'ativo',           label: 'Status', render: (s) => <StatusCell ativo={s.ativo} /> },
        { key: 'aliquota_iss',    label: 'ISS',    render: (s) => <PctCell v={s.aliquota_iss} /> },
        { key: 'aliquota_pis',    label: 'PIS',    render: (s) => <PctCell v={s.aliquota_pis} /> },
        { key: 'aliquota_cofins', label: 'COFINS', render: (s) => <PctCell v={s.aliquota_cofins} /> },
        { key: 'aliquota_csll',   label: 'CSLL',   render: (s) => <PctCell v={s.aliquota_csll} /> },
        { key: 'aliquota_ir',     label: 'IR',     render: (s) => <PctCell v={s.aliquota_ir} /> },
        { key: 'aliquota_inss',   label: 'INSS',   render: (s) => <PctCell v={s.aliquota_inss} /> },
      ]}
    />
  );
}
